module.exports = __webpack_public_path__ + "media/images/background-7-5101eda1e20366128b82e60dd29e809b.svg";